import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import size from 'lodash/size';
import first from 'lodash/first';

import { Message, Attachment } from 'models';

import * as chatAppActions from '../../../app/ChatApp/actions';
import * as chatAppSelectors from '../../../app/ChatApp/selectors';
import { staticStyles as styles } from './styles';
import ChatMessageForCustomer from '../ChatMessageForCustomer';
import ChatMessageForUser from '../ChatMessageForUser';
import messages from './messages';

export class ChatMessage extends PureComponent {
  constructor(props) {
    super(props);

    this.registerDOMNode = this.registerDOMNode.bind(this);
    this.handleFailedRetry = this.handleFailedRetry.bind(this);
  }

  componentWillMount() {
    const { message } = this.props;
    const attachments = message.attachments;
    if (size(attachments)) {
      const attachment = first(attachments);
      this.props.fetchMessageAttachment(message.id, attachment.id);
    }
  }

  registerDOMNode(dom) {
    const { provideDOMNode } = this.props;
    provideDOMNode(dom);
  }

  handleFailedRetry(e) {
    e.preventDefault();
    this.props.onRetry(this.props.message);
  }

  renderFailed() {
    const { message, intl } = this.props;
    if (!message.failed) return null;

    return (
      <div style={styles.failed} title={intl.formatMessage(messages.sent_failure)} onClick={this.handleFailedRetry} />
    );
  }

  renderBodyForType() {
    const { message, short, attachment } = this.props;

    if (message.sentBy.type === 'customer') {
      return <ChatMessageForCustomer message={message} attachment={attachment} />;
    } else if (message.sentBy.type === 'user') {
      return <ChatMessageForUser message={message} attachment={attachment} hideAvatar={short} />;
    }

    return null;
  }

  render() {
    const { short } = this.props;
    const style = Object.assign({}, styles.message);
    if (short) {
      style.marginTop = '5px';
    }

    return (
      <div style={style} ref={this.registerDOMNode}>
        {this.renderBodyForType()}
        {this.renderFailed()}
      </div>
    );
  }
}

ChatMessage.propTypes = {
  attachment: React.PropTypes.instanceOf(Attachment),
  message: React.PropTypes.instanceOf(Message),
  short: React.PropTypes.bool,
  provideDOMNode: React.PropTypes.func,
  onRetry: React.PropTypes.func,
  intl: intlShape.isRequired,
  fetchMessageAttachment: React.PropTypes.func,
};

ChatMessage.defaultProps = {
  attachment: Attachment(),
  provideDOMNode: () => {},
  onRetry: () => {},
  fetchMessageAttachment: () => {},
  message: Message(),
  short: false,
};

export const mapStateToProps = (state, props) => {
  const selectMessageAttachments = chatAppSelectors.makeSelectMessageAttachment();
  return {
    attachment: selectMessageAttachments(state, props),
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    fetchMessageAttachment(messageId, attachmentId) {
      if (!messageId && !attachmentId) return;
      dispatch(chatAppActions.fetchMessageAttachment(messageId, attachmentId));
    },
  };
};

export const intlChatMessage = injectIntl(ChatMessage, { withRef: true });

export default connect(mapStateToProps, mapDispatchToProps)(intlChatMessage);
